import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';
// Custom hook to track page views on route changes
export const usePageTracking = () => {
    const location = useLocation();
    useEffect(() => {
        // Track page view whenever the route changes
        const path = location.pathname + location.search;
        trackPageView(path);
    }, [location]);
};
